"use strict";

var _interopRequireWildcard = require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));

var _toConsumableArray2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

var _objectSpread2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/objectSpread2.js"));

var _createForOfIteratorHelper2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.array.splice.js");

require("core-js/modules/es.function.name.js");

var report = _interopRequireWildcard(require("@/api/report"));

var _Pagination = _interopRequireDefault(require("@/components/Pagination"));

var _Agency = _interopRequireDefault(require("@/components/Agency"));

var _exportReportExcel = require("./export-report-excel");

var _moment = _interopRequireDefault(require("moment"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    Pagination: _Pagination.default,
    Agency: _Agency.default
  },
  computed: {
    isAdmin: function isAdmin() {
      return this.$store.getters.roles.includes("admin");
    }
  },
  data: function data() {
    return {
      loadingButton: false,
      listQuery: {
        page: 1,
        limit: 10
      },
      total: 0,
      userLevel: this.$store.getters.agencyLevel,
      isLoading: false,
      arrAcengy: {},
      arrTableData: [],
      tableData: [],
      arrLevel: [],
      summary: {
        used: 0,
        free: 0,
        removed: 0
      },
      loadingDownload: false,
      labelLevel: [{}, {
        id: "Master Agent ID",
        name: "Master Agent Name"
      }, {
        id: "Distributor ID",
        name: "Distributor Name"
      }, {
        id: "Retailer ID",
        name: "Retailer Name"
      }, {
        id: "Employee ID",
        name: "Employee Name"
      }]
    };
  },
  watch: {},
  methods: {
    fromNow: function fromNow(dateTime) {
      var current = (0, _moment.default)();
      var time = (0, _moment.default)(dateTime);
      return current.diff(time, "day");
    },
    downloadExcel: function downloadExcel(status) {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var data, _iterator, _step, item, res, list;

        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = [];
                _this.loadingDownload = true;
                _context.prev = 2;
                _iterator = (0, _createForOfIteratorHelper2.default)(_this.tableData);
                _context.prev = 4;

                _iterator.s();

              case 6:
                if ((_step = _iterator.n()).done) {
                  _context.next = 14;
                  break;
                }

                item = _step.value;
                _context.next = 10;
                return (0, report.inventoryAgencyDetail)({
                  userId: _this.userSelect(item),
                  status: status
                });

              case 10:
                res = _context.sent;
                data = [].concat((0, _toConsumableArray2.default)(data), (0, _toConsumableArray2.default)(res.data));

              case 12:
                _context.next = 6;
                break;

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](4);

                _iterator.e(_context.t0);

              case 19:
                _context.prev = 19;

                _iterator.f();

                return _context.finish(19);

              case 22:
                // console.log("data ne", data);
                list = data.map(function (e) {
                  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
                    agingDevices: _this.fromNow(e.created_at)
                  });
                });
                (0, _exportReportExcel.exportReportInventoryDetail)(list);

              case 24:
                _context.prev = 24;
                _this.loadingDownload = false;
                return _context.finish(24);

              case 27:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2,, 24, 27], [4, 16, 19, 22]]);
      }))();
    },
    userSelect: function userSelect(row) {
      var res = [];

      for (var i = 1; i <= this.level; i++) {
        var id = void 0;

        if (row["lv".concat(i)]) {
          id = row["lv".concat(i)].split("|")[1];
        } else {
          id = null;
        }

        res.push("".concat(i, "-").concat(id));
      }

      return JSON.stringify(res);
    },
    doSearchGroup: function doSearchGroup() {
      var _this2 = this;

      var agency = this.$refs["agency"].getData();
      var levels = {
        lv1: agency.lv1,
        lv2: agency.lv2,
        lv3: agency.lv3,
        lv4: agency.lv4
      };
      var flag = false;
      Object.keys(levels).forEach(function (key, index) {
        if (levels[key]) {
          _this2.level = index + 1;
          flag = true;
        }
      });

      if (!flag) {
        return this.$message({
          type: "error",
          message: "Please select agent"
        });
      }

      this.loadingButton = true;
      this.listQuery.levels = levels;
      report.inventoryGroup(this.listQuery).then(function (res) {
        _this2.tableData = res.data.data;
        _this2.summary = {
          used: _this2.tableData.reduce(function (prev, cur) {
            return prev + +cur.used;
          }, 0),
          free: _this2.tableData.reduce(function (prev, cur) {
            return prev + +cur.free;
          }, 0),
          removed: _this2.tableData.reduce(function (prev, cur) {
            return prev + +cur.removed;
          }, 0)
        };
        _this2.total = res.data.total;

        if (!_this2.total) {
          _this2.$notify({
            type: "warning",
            message: "Not found"
          });
        }
      }).finally(function () {
        _this2.loadingButton = false;
      });
    },
    removeArrDataTable: function removeArrDataTable(level) {
      level++;
      var index = null;
      this.arrTableData.forEach(function (data, i) {
        data.forEach(function (element) {
          if (element.level == level) {
            index = i;
          }
        });
      });
      if (index) this.arrTableData.splice(index, 5 - level);
    },
    labelUserIdChild: function labelUserIdChild(index) {
      return this.labelLevel[this.arrLevel[index]].id;
    },
    labelUserNameChild: function labelUserNameChild(index) {
      return this.labelLevel[this.arrLevel[index]].name;
    },
    getInventoryAgencyChild: function getInventoryAgencyChild(userId, level, index) {
      var _this3 = this;

      this.isLoading = true;
      report.inventoryAgencyChild(userId).then(function (res) {
        if (res.data.length) {
          _this3.removeArrDataTable(level);

          _this3.arrTableData.push(res.data);

          _this3.arrLevel.push(res.data[0].level);
        } else {
          _this3.arrTableData.splice(index + 1, _this3.arrTableData.length + 1 - index);
        }
      }).finally(function () {
        _this3.isLoading = false;
      });
    },
    getInventoryAllLevel: function getInventoryAllLevel() {
      var _this4 = this;

      var level = null;
      Object.keys(this.agency).forEach(function (key) {
        if (_this4.agency[key]) {
          level = key.split("lv")[1];
        }
      });
      var data = {
        level: level
      };
      this.isLoading = true;
      report.inventoryAllLevel(data).then(function (res) {
        _this4.arrTableData = [];
        _this4.arrLevel = [];
        Object.keys(res.data).forEach(function (key) {
          _this4.arrLevel.push(key);

          _this4.arrTableData.push(res.data[key]);
        });
      }).finally(function () {
        _this4.isLoading = false;
      });
    },
    getInventoryAgencyParent: function getInventoryAgencyParent() {
      var _this5 = this;

      var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var level = arguments.length > 2 ? arguments[2] : undefined;
      var data = {};

      if (!userId) {
        Object.keys(this.agency).forEach(function (key) {
          if (!isNaN(_this5.agency[key]) && _this5.agency[key]) {
            userId = _this5.agency[key];
          }
        });
        data = {
          userId: userId,
          isParent: false
        };
      } else {
        data = {
          userId: userId,
          isParent: true
        };
      }

      if (!userId && !this.isAdmin) {
        return this.$message({
          type: "error",
          message: "Please select agent"
        });
      } else if (!userId && this.isAdmin) {
        return this.getInventoryAllLevel();
      }

      this.isLoading = true;
      report.inventoryAgency(data).then(function (res) {
        if (res.data) {
          if (!search) {
            _this5.removeArrDataTable(level);
          } else {
            _this5.arrTableData = [];
            _this5.arrLevel = [];
          }

          _this5.arrTableData[_this5.arrTableData.length] = [];

          _this5.arrTableData[_this5.arrTableData.length - 1].push(res.data);

          _this5.arrLevel.push(res.data.level);
        }
      }).finally(function () {
        _this5.isLoading = false;
      });
    }
  }
};
exports.default = _default;